var sound_control_default = {
  "root": "TWuCi",
  "sliderContainer": "hKgAr"
};
export {
  sound_control_default as default
};
//# sourceMappingURL=sound-control-scss.js.map
